module.exports = __webpack_public_path__ + "assets/img/biaoQian.07e5a570.svg";